


































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import IRolePermission from '@/store/models/IRolePermission';
import IStock from '@/store/models/IStock';
import FilterMenu from '@/components/shared/FilterMenu.vue';
import ISellProduct from '@/store/models/ISellProduct';

@Component({
    components: {
        FilterMenu
    }
})
export default class SellsDetailPalletStockSelector extends Vue {
    @Prop({ type: Array, required: true })
    Permissions!: IRolePermission[];

    @Prop()
    value!: IStock[];

    @Prop({ type: Array, required: true })
    SelectedSellProduct!: ISellProduct[];

    @Prop({ type: Array, required: true })
    StockList!: IStock[];

    @Prop({ type: Boolean, default: false })
    ScannerActive!: boolean;

    @Prop({ default: false })
    overlay!: boolean;

    selectedStockCustomerToSell: IStock[] = [];
    searchCustomerStock: string = "";
    dialog: boolean = false;
    sortBy: string = 'goodName';
    sortDesc: boolean = false;

    get headers() {
        const baseHeaders = [
            { text: 'Good', align: 'start', value: 'goodName' },
            { text: 'Inbound', value: 'codeInbounds' },
            { text: 'Warehouse', value: 'warehouseName' },
            { text: 'Pallet type', value: 'listPalletName' },
            { text: 'Pallet Id', value: 'idPallet' },
            { text: 'Weight', value: 'weight' },
            { text: 'Location', value: 'location' },
            { text: 'Total cases', value: 'totalCases' }
        ];

        if (this.ScannerActive) {
            baseHeaders.push({ text: 'Id Pallet Customer', value: 'idPalletCustomer' });
        }

        return baseHeaders;
    }

    get currentSellProduct(): ISellProduct {
        return this.SelectedSellProduct && this.SelectedSellProduct.length > 0
            ? this.SelectedSellProduct[0]
            : {} as ISellProduct;
    }

    get StockListFiltered(): IStock[] {
        if (this.SelectedSellProduct && this.SelectedSellProduct.length > 0) {
            const stock = this.StockList.filter(i => i.totalCases === this.SelectedSellProduct[0].totalCases);
            if (stock.length === 0 && this.StockList.length > 0) {
                return this.StockList;
            }
            return stock;
        }
        return this.StockList;
    }

    get TotalPalletsSelected(): number {
        return this.selectedStockCustomerToSell.length;
    }

    get TotalCasesSelected(): number {
        return this.selectedStockCustomerToSell.reduce((sum, item) => sum + (item.totalCases || 0), 0);
    }

    get maxPalletAmount(): number {
        if (!this.SelectedSellProduct || this.SelectedSellProduct.length === 0) {
            return 0;
        }
        return this.SelectedSellProduct[0].totalCases - this.SelectedSellProduct[0].inSellDetailCases;
    }

    get remainingCases(): number {
        return this.maxPalletAmount;
    }

    get deltaCases(): number {
        return this.remainingCases - this.TotalCasesSelected;
    }

    get selectionStatusColor(): string {
        if (this.TotalCasesSelected === 0) return 'grey';
        if (this.deltaCases < 0) return 'red';
        if (this.deltaCases === 0) return 'green';
        return 'orange';
    }

    get selectionStatusText(): string {
        if (this.TotalCasesSelected === 0) return 'No pallets selected';
        if (this.deltaCases < 0) return `You exceeded by ${Math.abs(this.deltaCases)} cases`;
        if (this.deltaCases === 0) return 'Exact quantity selected';
        return `${this.deltaCases} cases still missing`;
    }

    @Watch('value')
    updateSelection(newValue: IStock[] | null) {
        if (!newValue || newValue.length === 0) {
            this.selectedStockCustomerToSell = [];
        }
    }

    @Watch('selectedStockCustomerToSell')
    onChangeselectedStockCustomerToSell() {
        if (this.selectedStockCustomerToSell.length > 0) {
            this.$emit('input', this.selectedStockCustomerToSell);
        } else {
            this.$emit('input', null);
        }
    }

    @Watch('dialog')
    onDialogChanged(val: boolean) {
        if (!val) {
            this.close();
        }
    }

    close(): void {
        this.dialog = false;
    }
}
